import { camelizeKeys } from 'humps'

const defaultState = {}

const releasedPlayers = (state, player) => {
  const playerIndex = state.selectedPlayers.findIndex(p => p.id == player.id)
  const newValue = [
    ...state.selectedPlayers.slice(0, playerIndex), 
    ...state.selectedPlayers.slice(playerIndex + 1, state.selectedPlayers.length)
  ]
  return newValue.length ? newValue : null
}

const directMessages = (state = defaultState, {type, payload}) => {
  switch (type) {
    case 'DIRECT_MESSAGES.INIT':
      return {...state, ...payload, channelId: null, messages: [], selectedPlayer: null, selectedPlayers: null, 
        limit: 10, loading: false}
    case 'DIRECT_MESSAGES.RECEIVED':
      return {...state, ...payload}
    case 'DIRECT_MESSAGES.FETCH_MORE':
      return {...state, scroll: null}
    case 'DIRECT_MESSAGES.LIMIT_INCREASED':
      return {...state, limit: payload.limit}
    case 'DIRECT_MESSAGES.CHANNEL_OPENED':
      return {...state, channelId: payload.id, messages: []}
    case 'DIRECT_MESSAGES.CHANNEL_NEW':
      return {...state, channelId: null, messages: []}
    case 'DIRECT_MESSAGES.CHANNEL_CLEAR':
      return {...state, channelId: null, messages: [], selectedPlayer: null}
    case 'DIRECT_MESSAGES.UPDATE_PLAYER':
      return {...state, players: state.players.map(p => p.id == payload.id ? _.pick(payload, ['id', 'first_name', 'last_name', 'image_url', 'has_app', 'phone']) : p)}
    case 'DIRECT_MESSAGES.CHANNELS_RECEIVED':
      return {...state, channels: payload.channels, players: payload.players, loading: false}
    case 'DIRECT_MESSAGES.SELECT_PLAYER':
      return {...state, selectedPlayer: payload, selectedPlayers: null, limit: 10}
    case 'DIRECT_MESSAGES.SELECT_PLAYERS':
      return {...state, selectedPlayers: payload.map(p => camelizeKeys(p))}
    case 'DIRECT_MESSAGES.SET_LOADING':
      return {...state, loading: payload}
    case 'DIRECT_MESSAGES.REMOVE_PLAYER':
      return {...state, selectedPlayers: releasedPlayers(state, payload)}
    default:
      return state
  }
}

export default directMessages
